<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.subprogram.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.subprogram.list.title"></app-i18n>
      </h1>

      <app-subprogram-list-toolbar></app-subprogram-list-toolbar>
      <app-subprogram-list-filter></app-subprogram-list-filter>
      <app-subprogram-list-table></app-subprogram-list-table>
    </div>
  </div>
</template>

<script>
import SubprogramListFilter from '@modules/subprogram/components/subprogram-list-filter.vue';
import SubprogramListTable from '@modules/subprogram/components/subprogram-list-table.vue';
import SubprogramListToolbar from '@modules/subprogram/components/subprogram-list-toolbar.vue';

export default {
  name: 'app-subprogram-list-page',

  components: {
    [SubprogramListFilter.name]: SubprogramListFilter,
    [SubprogramListTable.name]: SubprogramListTable,
    [SubprogramListToolbar.name]: SubprogramListToolbar,
  },
};
</script>

<style>
</style>
